// extracted by mini-css-extract-plugin
export default {"dialog-wrapper":"ConnectionDialog_dialog-wrapper__oLDSG"};